const dayjs = require('dayjs')
const some = require('lodash/some')
const concat = require('lodash/concat')
const compact = require('lodash/compact')

module.exports = (blackout, date, cake = false, cupcake = false, isSpecial = false) => {

  if(!date) {
    return false
  }

  date = dayjs(date)

  let today = dayjs()

  if (cake) {
    today = today.add(1, 'd')
  }

  if(isSpecial) {
    if (!some(blackout.specialActiveDates, o => dayjs(o.date).isSame(date, 'd'))) {
      return false
    }
  } else {
    if (date.day() < 4 && !date.isSame(dayjs('2022-06-29'),'day')) {
      return false
    }
  }
 
  if (!date.isAfter(today)) {
    return false
  }

  let dates = blackout.blackoutDates

  if(cake) {
    dates = concat(dates,blackout.cakes)
  }
  if(cupcake) {
    dates = concat(dates,blackout.cupcakes)
  }

  dates = compact(dates)

  if (some(dates, o => dayjs(o.date).isSame(date, 'd'))) {
    return false
  }

  return true
}
